import { title } from "assets/jss/material-kit-react.js";

const section = {
  padding: "15px 0",
  textAlign: "center",
  color: "black",
};

const productStyle = {
  section,
  emailSection: {
    ...section,
    backgroundImage: `url(${require("assets/img/banksy-fugl-crop.png")})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    paddingBlock: "40px",

    "@media (max-width: 768px)": {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1000,
      backgroundImage: "none",
      paddingLeft: "0px",
    },
  },
  card: {
    maxWidth: "700px",
    backgroundColor: "white",
    borderRadius: "1em",
    padding: "40px",
    textAlign: "left",
    display: "flex",
    flexDirection: "column",
    "@media (max-width: 768px)": {
      maxHeight: "calc(100vh - 180px)",
      overflowY: "auto",
      maxWidth: "90%",
      position: "relative",
      padding: "24px",
    },
  },
  title: {
    ...title,
    marginBottom: "1rem",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none",
  },
  description: {
    color: "#999",
  },
  titleContainer: {
    display: "flex",
    alignItems: "top",
    justifyContent: "space-between",
    fontSize: "32px",
    flexDirection: "row",
    gap: "12px",
    "@media (max-width: 768px)": {
      fontSize: "28px",
    },
    "@media (max-width: 500px)": {
      fontSize: "20px",
      fontWeight: 400,
    },
  },
  heartInTitle: {
    marginLeft: "2px",
    "@media (min-width: 400px)": {
      marginLeft: "12px",
    },
  },
  closeModalButton: {
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    alignSelf: "flex-start",
    paddingInline: "8px",
    "@media (min-width: 768px)": {
      display: "none",
    },
  },
  checkboxContainer: {
    display: "flex",
    alignItems: "center",
  },
  marginRight: {
    marginRight: "7px",
  },
  sendButton: {
    minWidth: "200px",
    minHeight: "60px",
    border: "1px solid black",
    alignSelf: "left",
    maxWidth: "100%",
    alignItems: "top",
    justifyContent: "center",
  },
  shareButtonsContainer: {
    alignSelf: "left",
  },
  sendButtonComplete: {
    alignSelf: "center",
    backgroundColor: "#23A366",
    color: "white",
    padding: "6px 30px",
    display: "flex",
  },
  inputContainer: {
    display: "flex",
  },
  intputContainerVertical: {
    display: "flex",
    flexDirection: "column",
  },
  sendButtonProgress: {
    color: "red",
    position: "absolute",
  },
  nameAndEmailContainer: {
    marginBottom: "20px",
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
  sectionTitle: {
    fontWeight: "bold",
    fontSize: "18px",
    lineHeight: "21px",
    color: "#383E56",
    marginTop: "20px",
    marginBottom: "0",
  },
};

export default productStyle;
